var _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7782 4H14.2227V5.32362C17.691 5.90549 20.3338 8.92189 20.3338 12.5556V15.6111C20.3338 15.9821 20.6005 16.4357 21.1386 16.9066C21.382 17.1195 21.6311 17.2914 21.8218 17.4106C21.9159 17.4694 21.9926 17.5134 22.0429 17.5413C22.068 17.5551 22.0863 17.5649 22.0967 17.5703L22.1057 17.575L22.7782 17.9113V22.3333H3.22266V17.9113L3.89479 17.5752L3.9042 17.5703C3.91458 17.5649 3.93288 17.5551 3.95797 17.5413C4.00831 17.5134 4.08496 17.4694 4.17905 17.4106C4.36976 17.2914 4.6189 17.1195 4.86226 16.9066C5.40035 16.4357 5.6671 15.9821 5.6671 15.6111V12.5556C5.6671 8.92189 8.3099 5.90549 11.7782 5.32362V4Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0004 26C14.3505 26 15.4449 24.9056 15.4449 23.5556H10.556C10.556 24.9056 11.6504 26 13.0004 26Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 7.16699,
    r: 6,
    fill: "#D92D20",
    stroke: "white",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.71061107835cd8e779027eb1e1ef9117.svg";
export { ForwardRef as ReactComponent };